<script>
	import PieceC from "./Piece.svelte";

	import { crate } from "../../../wasm.js";
	const { PieceKind, MoveKind } = crate;

	export let x;
	export let y;
	export let piece;
	export let dim = false;
	export let from = false;
	export let to = false;
	export let move = undefined;
	export let check = false;

	// $: if (move) {
	// 	console.log(move);
	// }

	$: pair = Math.trunc(x % 2) === Math.trunc(y % 2);

	$: canCapture = (move !== undefined) ? (move.capture !== null) : false;
	$: canMove = (move !== undefined && !canCapture) ? [MoveKind.Normal, MoveKind.TwoUp].includes(move.kind) : false;
	$: canCastle = (move !== undefined && !canCapture) ? [MoveKind.CastleLong, MoveKind.CastleShort].includes(move.kind) : false;
</script>

<div
	class="cell centered"
	class:pair
	class:from
	class:to
	class:impair={!pair}
	class:none={piece.kind === PieceKind.None}
	class:can-capture={canCapture || check}
	on:pointerup
	on:pointerdown
	on:pointerenter
	on:pointerleave
>
	{#if piece.kind !== PieceKind.None}
		<PieceC {piece} {dim} />
	{/if}
	{#if canMove}
		<div class="can-move" />
	{/if}
	{#if canCastle}
		<div class="can-castle" />
	{/if}
</div>

<style>
	.cell {
		width: 100%;
		height: 100%;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center;
		cursor: grab;
		position: relative;
	}

	.cell.none {
		cursor: default;
	}

	.cell.pair {
		background-color: #bba586;
	}
	.cell.impair {
		background-color: #6c533d;
	}

	.cell.from {
		background-color: #af8b24 !important;
	}
	.cell.to {
		background-color: #d6af3d !important;
	}

	.can-move {
		width: 35%;
		height: 35%;
		background-color: #b74c52;
		border-radius: 50%;
		position: absolute;
	}

	.can-capture, .can-capture.from, .can-capture.to {
		background-color: #b74c52 !important;
	}

	.can-castle {
		width: 35%;
		height: 35%;
		background-color: #338133;
		border-radius: 50%;
		position: absolute;
	}
</style>
